import { render, staticRenderFns } from "./Minutas.vue?vue&type=template&id=9b225a74&scoped=true&"
import script from "./Minutas.vue?vue&type=script&lang=js&"
export * from "./Minutas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b225a74",
  null
  
)

export default component.exports